import { render, staticRenderFns } from "./BaseQuillEditor.vue?vue&type=template&id=68762533"
import script from "./BaseQuillEditor.vue?vue&type=script&lang=ts"
export * from "./BaseQuillEditor.vue?vue&type=script&lang=ts"
import style0 from "./BaseQuillEditor.vue?vue&type=style&index=0&id=68762533&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports